import styled from 'styled-components';



export default styled.div`
  font-size: 5rem;
  font-weight: 100;
  height: 88%;
  display: flex;
  align-items: center;
  justify-content: center;
`;